import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

import { SliderScroll } from '../_app/cuchillo/components/SliderScroll';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { GetBy } from '../_app/cuchillo/core/Element';
import { ScrollItem__SliderCircular__Item } from './ScrollItem__SliderCircular';
import { ScrollItem__Default } from './ScrollItem__Default';
import { isMobile } from '../_app/cuchillo/core/Basics';

class ScrollItem__Services extends ScrollItem__Default {
    _call;
    _sliderTitle;
    _slider;
    _circular;

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        if (!isMobile) {
            const slider = GetBy.class('__slider', this.item)[0];
            this._slider = new SliderScroll(slider, {
                itemClass: ScrollItem__SliderCircular__ServiceItem,
                interaction: false,
                hasScrollbar: false
            });
        }

        this._call = () => this.loop();
    }

    triggerShow() {
        super.triggerShow();
        gsap.ticker.add(this._call);
    }

    triggerHide() {
        super.triggerHide();
        gsap.ticker.remove(this._call);
    }

    loop() {
        if (this._slider) this._slider.loop();
    }

    resize(w, h) {
        super.resize(w, h);
        if (this._slider) this._slider.resize();
        if (this._sliderTitle) this._sliderTitle.resize();
    }

    dispose() {
        if (this._sliderTitle) this._sliderTitle.dispose();
        if (this._slider) this._slider.dispose();
        super.dispose();
    }
}

export class ScrollItem__SliderCircular__ServiceItem extends ScrollItem__SliderCircular__Item {
    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        const overlay = GetBy.selector('.overlay div', __link)[0];
        new SplitText(overlay, {
            type: 'lines',
            linesClass: 'child'
        });
        new SplitText(overlay, {
            type: 'lines',
            linesClass: 'parent'
        });
    }

    //==================================================================================================================
    //          PUBLIC
    //==================================================================================================================
}


Scroll._registerClass('WidgetServices', ScrollItem__Services);
